/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-03-05 10:41:10
 * @LastEditors: changfeng
 * @LastEditTime: 2024-10-09 10:26:39
 */
import logo from "@/assets/images/logo.png";
import MetaLogo from "@/assets/logo/logo_fb.png";
import { connect } from "react-redux";
import style from "./logo.module.less";
import { Divider, Space } from "antd";

const Logo = (props: any) => {
	const { isCollapse } = props;
	return (
		<Space split={<Divider style={{ marginInline: '4px 4px' }} type="vertical" />} size={0}>
			<a href="/" style={{ textDecoration: "none" }}>
				<div className={style.logoBox}>
					<img src={logo} alt="logo" className={style.logoImg} />
					<span className={style.logoText}>AdSurgebot</span>
				</div>
			</a>
			<span className={style.fbLogo}>
				<img src={MetaLogo} alt="" />
			</span>
		</Space>
	);
};

const mapStateToProps = (state: any) => state.menu;
export default connect(mapStateToProps)(Logo);
